var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.wasMounted
    ? _c(
        "div",
        { staticClass: "boolean" },
        [
          _vm.schema.tooltip
            ? _c(
                "sc-tooltip",
                {
                  attrs: {
                    type: "is-light",
                    position: "is-right",
                    label: _vm.schema.tooltip
                  }
                },
                [
                  _c("sc-icon", {
                    attrs: { size: "is-small", icon: "info-circle" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("sc-field", {
            staticClass: "boolean__field",
            attrs: { label: _vm.schema.title }
          }),
          _vm._v(" "),
          _c("sc-switch", {
            on: {
              input: function($event) {
                _vm.onChange()
              }
            },
            model: {
              value: _vm.value[_vm.schema.name],
              callback: function($$v) {
                _vm.$set(_vm.value, _vm.schema.name, $$v)
              },
              expression: "value[schema.name]"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38a2ecc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a2ecc6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/fields/BooleanField.vue
// module id = null
// module chunks = 